import * as io from 'io-ts';

export const enumType = <EnumType>(enumName: string, theEnum: Record<string, string | number>) => {
    const isEnumValue = (input: unknown): input is EnumType => Object.values<unknown>(theEnum).includes(input);

    return new io.Type<EnumType>(enumName, isEnumValue, (input, context) => (isEnumValue(input) ? io.success(input) : io.failure(input, context)), io.identity);
};
